export default {
  DELIVERY_METHOD: 'DELIVERY_METHOD',
  DELIVERY_POSTCODE: 'DELIVERY_POSTCODE',
  DELIVERY_TIMEFRAME: 'DELIVERY_TIMEFRAME',
};
